import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList} from '@angular/core';
import {DataGridService} from './data-grid.service';
import {DataGridFieldsComponent} from './data-grid-fields/data-grid-fields.component';
import {DataGridFieldComponent} from './data-grid-fields/data-grid-field/data-grid-field.component';
import {DataGridSort} from './data-grid-sort/data-grid-sort';

@Component({
    selector: 'vui-data-grid',
    templateUrl: './data-grid.component.html',
    styleUrls: ['./data-grid.component.scss']
})
export class DataGridComponent implements AfterContentInit, OnInit {
    @ContentChildren(DataGridFieldComponent, {descendants: true}) public dataGridField: QueryList<DataGridFieldComponent>;
    @ContentChildren(DataGridFieldsComponent, {descendants: false}) public dataGridFields: QueryList<DataGridFieldsComponent>;
    public intersectionObserver: IntersectionObserver;
    @Input() public loaded: boolean;
    @Output() public query$: EventEmitter<string>;
    @Input() public sort: DataGridSort;
    @Output() public sorted$: EventEmitter<DataGridSort>;
    @Output() public scrolled$: EventEmitter<boolean>;

    constructor(private dataGridService: DataGridService) {
        this.dataGridField = new QueryList<DataGridFieldComponent>();
        this.dataGridFields = new QueryList<DataGridFieldsComponent>();
        this.loaded = false;
        this.query$ = new EventEmitter<string>();
        this.scrolled$ = new EventEmitter<boolean>();
        this.sorted$ = new EventEmitter<DataGridSort>();
    }

    ngAfterContentInit(): void {
        this.dataGridFields.changes.subscribe(() => {
            this.intersectionObserver.observe(this.dataGridFields.last.elementRef.nativeElement);
        });
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                this.scrolled$.emit(entry.isIntersecting);
            }
        });
    }

    ngOnInit(): void {
        this.dataGridService.query$.subscribe((query) => {
            this.query$.emit(query);
        });
        this.dataGridService.sort$.next(this.sort);
        this.dataGridService.sort$.subscribe((dataGridSort) => {
            this.sorted$.emit(dataGridSort);
        });
    }
}
